// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* input css box */
.BDxa8VE_YLhxnXpTAgCC {
  flex: 1;
  border: 1px solid var(--text-color);
  outline: none;
  padding: 0.5em;
  color: var(--text-color);
  background-color: var(--input-color);
  border-radius: var(--border-radius);
  width: 100%;
  box-sizing: border-box;
  font-size: 1em;
  font-weight: 400;
  font-family: var(--text-font);
}

.BDxa8VE_YLhxnXpTAgCC:focus {
  border: 1px solid var(--card-color);
}

.BDxa8VE_YLhxnXpTAgCC:focus::placeholder {
  color: transparent;
}
`, "",{"version":3,"sources":["webpack://./src/styles/Input.module.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;EACE,OAAO;EACP,mCAAmC;EACnC,aAAa;EACb,cAAc;EACd,wBAAwB;EACxB,oCAAoC;EACpC,mCAAmC;EACnC,WAAW;EACX,sBAAsB;EACtB,cAAc;EACd,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":["/* input css box */\n.textInput {\n  flex: 1;\n  border: 1px solid var(--text-color);\n  outline: none;\n  padding: 0.5em;\n  color: var(--text-color);\n  background-color: var(--input-color);\n  border-radius: var(--border-radius);\n  width: 100%;\n  box-sizing: border-box;\n  font-size: 1em;\n  font-weight: 400;\n  font-family: var(--text-font);\n}\n\n.textInput:focus {\n  border: 1px solid var(--card-color);\n}\n\n.textInput:focus::placeholder {\n  color: transparent;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"textInput": `BDxa8VE_YLhxnXpTAgCC`
};
export default ___CSS_LOADER_EXPORT___;
